"use client";

export default function ScrollDownButton({ targetId }: { targetId: string }) {
  return (
    <button
      onClick={() => {
        const target = document.getElementById(targetId);
        if (target) {
          const next = target.nextElementSibling as HTMLElement | null;
          if (next) next.scrollIntoView({ behavior: "smooth" });
        }
      }}
      className="mt-10 flex flex-col items-center gap-1.5 mx-auto group cursor-pointer"
      aria-label="Scroll down to learn more"
    >
      <span className="text-[9px] tracking-[0.3em] uppercase text-black/40 group-hover:text-black/70 transition-colors font-medium">
        Learn more
      </span>
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        className="text-black/30 group-hover:text-black/60 transition-colors animate-bounce"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  );
}
